import { useMutation, useQuery } from 'react-query';
import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import api from '../../../../../components/api';
import { yupErrorMsg } from '../../../../../components/atoms/const';

function useRenderTableRefund(status: 'PAID' | 'UNPAID' | null, page: number) {
  const { data: refundRes, isLoading: refundLoad, refetch } = useQuery(
    // eslint-disable-next-line no-nested-ternary
    [status === 'PAID' ? 'getAllPaidRefund' : status === 'UNPAID' ? 'getAllUnpaidRefund' : 'getAllRefund', 'customerSupport', page - 1, 10],
    () => {
      if (status === 'PAID') {
        return api.customerSupport.getAllPaidRefund(page - 1, 10);
      } if (status === 'UNPAID') {
        return api.customerSupport.getAllUnPaidRefund(page - 1, 10);
      }
      return api.customerSupport.getAllRefund(page - 1, 10);
    },
  );
  const refundData = React.useMemo(() => ({
    data: refundRes?.data?.data,
    totalPages: refundRes?.data?.totalPages ?? 1,
  }), [refundRes]);

  const [result, setResult] = React.useState<any>(undefined);
  const { mutate: sendRefund, isLoading: sendRefundLoad } = useMutation(api.customerSupport.sendRefund, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      setResult(data);
    },
    onError: (error) => {
      console.log(error);
      setResult(error);
    },
  });

  const yupSchema = yup.object({
    refundAmount: yup.number().min(0, yupErrorMsg.REFUND_AMOUNT_POSITIVE).required(yupErrorMsg.REFUND_AMOUNT_EMPTY),
  });
  const formik = useFormik({
    initialValues: {
      refundAmount: 0,
      id: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => sendRefund(values),
  });

  const afterSendRefund = () => {
    refetch().catch((e) => console.log(e));
    setResult(undefined);
  };

  return {
    refund: {
      data: refundData?.data,
      totalPages: refundData?.totalPages,
      load: refundLoad,
    },
    formik,
    modal: {
      load: sendRefundLoad,
      after: afterSendRefund,
      result,
    },
  };
}

export default useRenderTableRefund;
